import React, { BaseSyntheticEvent, useEffect } from 'react'
import { IonButton, IonButtons, IonChip, IonGrid, IonIcon, IonLabel, IonRow, IonToolbar } from '@ionic/react'
import { chevronForward, closeCircleOutline } from 'ionicons/icons'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getPatientMedicalHistorySelector } from '../../selectors'
import MultiSelectButtons from '../../../../components/multiSelectButtons/MultiSelectButtons.component'
import { IOption, IOptions } from '../../../../common/common.types'
import './MedicalHistoryButtons.component.css'
import { useHistory } from 'react-router-dom'
import { TabConstants } from '../../../../components/tabs/Tabs.constants'
import { initializeSearch } from '../../../../components/search/store/search.actions'
import { isTablet } from '../../../../utilities'
import { setSelectedOption } from '../../../patientInformation/store/patientInformation.actions'
import { PatientInformationConstants } from '../../../patientInformation/store/patientInformation.constants'
import { getPatientMedicalHistoryOptionsSelector } from '../../../options/selectors'
import {
  setSelectedMedicalHistory,
  setSelectedMedicalHistoryIcdNemsisBasic,
  setSelectedMedicalHistoryPNNV,
} from '../../store/patientMedicalHistory.actions'
import { IConfigurationsState } from '../../../configurations/store/configurations.types'
import { getConfigurationsSelector } from '../../../configurations/selectors'
import { PatientMedicalHistoryLayoutOptionsConstants } from '../../store/patientMedicalHistoryLayoutOptions.constants'
import _ from 'lodash'

const MedicalHistoryButtons: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const patientMedicalHistory = useSelector(getPatientMedicalHistorySelector)
  const { medicalHistory, medicalHistoryIcdNemsisBasic, medicalHistoryPNNV } = patientMedicalHistory
  const patientMedicalHistoryOptions = useSelector(getPatientMedicalHistoryOptionsSelector)
  const {
    medicalHistoryOptions,
    medicalHistoryOptionsFullList,
    medicalHistoryIcdNemsisBasicOptions,
    medicalHistoryIcdNemsisBasicOptionsFullList,
  } = patientMedicalHistoryOptions
  const configuration: IConfigurationsState = useSelector(getConfigurationsSelector)
  const { serviceConfig } = configuration

  const savedMedicalHistoryChip =
    serviceConfig.PR_PMHX_LAYOUT === PatientMedicalHistoryLayoutOptionsConstants.ICD_10_NEMSIS_BASIC
      ? [...medicalHistoryIcdNemsisBasic, ...medicalHistory]
      : medicalHistory

  const savedMedicalHistory = medicalHistory
  const savedMedicalHistoryIcdNemsisBasic = medicalHistoryIcdNemsisBasic

  const onSelectMedicalHistory = (e: BaseSyntheticEvent, options: IOptions) => {
    e.preventDefault()
    dispatch(setSelectedMedicalHistoryPNNV(null))
    dispatch(setSelectedMedicalHistory(options))
  }

  const onSelectMedicalHistoryIcdNemsisBasic = (e: BaseSyntheticEvent, options: IOptions) => {
    e.preventDefault()
    dispatch(setSelectedMedicalHistoryPNNV(null))
    dispatch(setSelectedMedicalHistoryIcdNemsisBasic(options))
  }

  const openMedicalHistoryLookup = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    if (serviceConfig.PR_PMHX_LAYOUT === PatientMedicalHistoryLayoutOptionsConstants.ICD_10_NEMSIS_BASIC) {
      dispatch(initializeSearch(medicalHistoryIcdNemsisBasicOptionsFullList))
    } else {
      dispatch(initializeSearch(medicalHistoryOptionsFullList))
    }
    if (isTablet()) {
      dispatch(setSelectedOption(PatientInformationConstants.PATIENT_MEDICAL_HISTORY_SEARCH_LIST_OPTION))
    } else {
      history.push(TabConstants.MEDICAL_HISTORY_LOOKUP)
    }
  }

  const removeFilterChip = (id: number | undefined, name: string | undefined) => {
    if (serviceConfig.PR_PMHX_LAYOUT === PatientMedicalHistoryLayoutOptionsConstants.ICD_10_NEMSIS_BASIC) {
      if (id === -99 || id === 0) {
        savedMedicalHistory.splice(
          savedMedicalHistory.findIndex((o) => o.name === name),
          1
        )
        dispatch(setSelectedMedicalHistory(savedMedicalHistory))
      } else {
        savedMedicalHistoryIcdNemsisBasic.splice(
          savedMedicalHistoryIcdNemsisBasic.findIndex((o) => o.id === id),
          1
        )
        dispatch(setSelectedMedicalHistoryIcdNemsisBasic(savedMedicalHistoryIcdNemsisBasic))
      }
    } else {
      if (id === -99 || id === 0) {
        savedMedicalHistory.splice(
          savedMedicalHistory.findIndex((o) => o.name === name),
          1
        )
      } else {
        savedMedicalHistory.splice(
          savedMedicalHistory.findIndex((o) => o.id === id),
          1
        )
      }
      dispatch(setSelectedMedicalHistory(savedMedicalHistory))
    }
  }

  useEffect(() => {
    setTimeout(() => {
      const content: HTMLIonContentElement | null = document.querySelector('#medical-history-buttons-row')
      content?.scrollTo(content?.scrollWidth, 0)
    }, 10)
  }, [savedMedicalHistoryChip])

  return (
    <>
      {savedMedicalHistoryChip.length > 0 || !_.isEmpty(medicalHistoryPNNV) ? (
        <IonToolbar>
          <IonGrid class='ion-no-padding'>
            <IonRow class='ion-nowrap no-flex-shrink' id='medical-history-buttons-row'>
              {savedMedicalHistoryChip &&
                savedMedicalHistoryChip.map((option: IOption) => (
                  <IonChip
                    data-testid={`Chip${option.id}`}
                    key={`Chip_${option.id}${option.name}`}
                    className='lookup-search-chips'>
                    <IonLabel>{option.name}</IonLabel>
                    <IonIcon
                      color='white'
                      icon={closeCircleOutline}
                      onClick={() => removeFilterChip(option.id, option.name)}
                    />
                  </IonChip>
                ))}
              {medicalHistoryPNNV && (
                <IonChip
                  data-testid={`PNNVChip${medicalHistoryPNNV.id}`}
                  key={`PNNVChip_${medicalHistoryPNNV.id}${medicalHistoryPNNV.name}`}
                  className='lookup-search-chips'>
                  <IonLabel>{medicalHistoryPNNV.name}</IonLabel>
                  <IonIcon
                    color='white'
                    icon={closeCircleOutline}
                    onClick={() => dispatch(setSelectedMedicalHistoryPNNV(null))}
                  />
                </IonChip>
              )}
            </IonRow>
          </IonGrid>
        </IonToolbar>
      ) : (
        <IonRow>
          <IonToolbar color='light' className='labelHeader'>
            <IonLabel color='medium'>{t('patientMedicalHistory.HistoryLabel')}</IonLabel>
          </IonToolbar>
        </IonRow>
      )}
      <IonToolbar className='toolbar-padding'>
        <IonLabel className='toolbar-label' slot='start'>
          {t('patientMedicalHistory.CommonConditions')}
        </IonLabel>
        <IonButtons slot='end'>
          <IonButton
            data-testid='More'
            color='primary-alt'
            className='toolbar-button'
            onClick={openMedicalHistoryLookup}>
            {t('common.buttons.FindMore')}
            <IonIcon icon={chevronForward} />
          </IonButton>
        </IonButtons>
      </IonToolbar>
      <hr />
      <MultiSelectButtons
        dataTestId={'MedicalHistoryButtons'}
        options={
          serviceConfig.PR_PMHX_LAYOUT === PatientMedicalHistoryLayoutOptionsConstants.ICD_10_NEMSIS_BASIC
            ? medicalHistoryIcdNemsisBasicOptions
            : medicalHistoryOptions
        }
        selectAction={
          serviceConfig.PR_PMHX_LAYOUT === PatientMedicalHistoryLayoutOptionsConstants.ICD_10_NEMSIS_BASIC
            ? onSelectMedicalHistoryIcdNemsisBasic
            : onSelectMedicalHistory
        }
        selectedOptions={
          serviceConfig.PR_PMHX_LAYOUT === PatientMedicalHistoryLayoutOptionsConstants.ICD_10_NEMSIS_BASIC
            ? medicalHistoryIcdNemsisBasic
            : medicalHistory
        }
        color={'zoll-blue-secondary'}
      />
    </>
  )
}

export default MedicalHistoryButtons
